<div class="dasboard-width font-13">
  <div class="row header mar-lft-rgt-0">
    <div class="col-md-4">View Document</div>
    <div class="col-md-4"> {{clientName}}</div>
    <div class="col-md-4">
      <ol class="breadcrumb cust-bread ">
        <li class="breadcrumb-item"><a class="pointer" (click)="changeRouting('dashboard')"><i
          class="fa fa-dashboard"></i> Home</a></li>
        <li class="breadcrumb-item active" aria-current="page">View Document</li>
      </ol>
    </div>
  </div>
  <div class="content mr-top-5 ">
    <div class="row mar-lft-rgt-0">
      <div class="col-md-12">
        <div class="box-prop pad-15">
          <label class="col-form-label pad-top-0 font-900">Category Wise Search : </label>
          <select class="custom-select  tcktyp" *ngFor="let ticket of ticketTypes;"
                  (change)="onCategoryChange(ticket,$event.target.value)" id="ticket_{{ticket.id}}">
            <option *ngFor="let option of ticket.options" [value]="option|json">{{option.title}}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row mar-lft-rgt-0 ">
      <div class="col-md-4  pad-top-16">
        <div class="box-prop pad-15">
          <label class="col-form-label pad-top-0 font-900">Email Wise Search : </label>
          <div class="form-group mar-bot-0">
            <input type="text" id='searchEmail' [(ngModel)]="emailSearch" placeholder="Search By Email Id"
                   (keydown.enter)="searchWithEmail($event)">
          </div>
        </div>
      </div>
      <div class="col-md-8 pad-top-16">
        <div class="box-prop pad-15">
<!--          <label class="col-form-label pad-top-0 font-900">Date Wise Search : </label>-->
<!--          <div class="form-group row mar-lft-rgt-0 mar-bot-0">-->
<!--            <input [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3" class="form-control col-sm-4 radius-0 font-13"-->
<!--                   [(ngModel)]="rDate" placeholder="Start Date">-->
<!--            <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time>&nbsp;&nbsp;-->
<!--            <input [owlDateTimeTrigger]="dt4" [owlDateTime]="dt4" class="form-control col-sm-4 radius-0 font-13"-->
<!--                   [(ngModel)]="dDate" placeholder="End Date">-->
<!--            <owl-date-time [pickerType]="'calendar'" #dt4></owl-date-time>&nbsp;&nbsp;-->
<!--            <button class="btn btn-success col-sm-2 radius-0 font-13"(click)="dateSearch()">Search</button>-->
<!--          </div>-->
          <label class="col-form-label pad-top-0 font-900">Text Wise Search : </label>
          <div class="form-group row mar-lft-rgt-0 mar-bot-0">
            <input type="text" class="form-control radius-0 font-13 col-sm-8 form-data"
                   placeholder="Search Within Documents..."
                   [(ngModel)]="textSelected"
                   matInput [formControl]="searchTerm"
                   [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngIf="isLoading" class="is-loading">
                <mat-spinner diameter="50"></mat-spinner>
              </mat-option>
              <ng-container *ngIf="!isLoading">
                <mat-option *ngFor="let zone of docs" [value]="zone.searchword">
                  {{ zone.searchword }}
                </mat-option>
              </ng-container>
            </mat-autocomplete>
            &nbsp;&nbsp;<button class="btn btn-success radius-0 col-sm-2 font-13" (click)="textSearch()">Search</button>
          </div>
        </div>

      </div>
    </div>
<!--    <div class="row mar-lft-rgt-0">-->
<!--      <div class="col-sm-12 pad-top-16 ">-->
<!--        <div class="box-prop pad-15 ">-->
<!--          <label class="col-form-label pad-top-0 font-900">Text Wise Search : </label>-->
<!--          <div class="form-group row mar-lft-rgt-0 mar-bot-0">-->
<!--            <input type="text" class="form-control radius-0 font-13 col-sm-8 form-data"-->
<!--                   placeholder="Search Within Documents..."-->
<!--                   [(ngModel)]="textSelected"-->
<!--                   matInput [formControl]="searchTerm"-->
<!--                   [matAutocomplete]="auto">-->
<!--            <mat-autocomplete #auto="matAutocomplete">-->
<!--              <mat-option *ngIf="isLoading" class="is-loading">-->
<!--                <mat-spinner diameter="50"></mat-spinner>-->
<!--              </mat-option>-->
<!--              <ng-container *ngIf="!isLoading">-->
<!--                <mat-option *ngFor="let zone of docs" [value]="zone.searchword">-->
<!--                  {{ zone.searchword }}-->
<!--                </mat-option>-->
<!--              </ng-container>-->
<!--            </mat-autocomplete>-->
<!--            &nbsp;&nbsp;<button class="btn btn-success radius-0 col-sm-2 font-13" (click)="textSearch()">Search</button>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--    </div>-->
    <div class="row mar-lft-rgt-0 mar-top-9">
      <div class="col-sm-12 pad-top-16 ">
        <div class="box-prop-top pad-15 ">
          <label class="col-form-label pad-top-0 font-900">Search Result : </label>
          <div class="card-body-grid1">
            <angular-slickgrid gridId="grid"
                               [columnDefinitions]="columnDefinitions"
                               [gridOptions]="gridOptions"
                               (onAngularGridCreated)="angularGridReady($event)"
                               (sgOnClick)="onCellClicked($event.detail.eventData, $event.detail.args)"
                               [dataset]="dataset">
            </angular-slickgrid>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Document Id:{{dId}} <span class="close" (click)="c()" aria-hidden="true">&times;</span>
    </div>

  </div>
  <div class="modal-body modal-height pad-top-0">
    <mat-tab-group (selectedTabChange)="tabClick($event)">
      <mat-tab label="Document Details">
        <div class="row mar-top-15">
          <div class="col-md-12">
            <select class="custom-select  tcktyp" *ngFor="let ticket of categories" [disabled]="false"
                    (change)="onTicketChange(ticket,$event.target.value)">
              <option *ngFor="let option of ticket.options" [value]="option|json">{{option.title}}</option>
            </select>
          </div>
        </div>
        <div class="row mar-lft-rgt-0 mar-top-9">
          <div class="col-sm-3">
            <span class="type">Creator:</span>&nbsp; <span class="status">{{creator}}</span>
          </div>
          <div class="col-sm-3 text-center">
            <app-material-fileupload *ngIf="upload" [formData]="formData" [target]="fileUploadUrl" [text]="uploadButtonName"
                                     (complete)="onFileComplete($event)"></app-material-fileupload>
          </div>
          <div class="col-sm-3 text-center" *ngIf="download">
            <button mat-button color="warn" (click)="downloadFile()">
              <mat-icon>file_download</mat-icon>
              Download Zip File
            </button>
          </div>
        </div>
        <div class="row mar-top-9">
          <div class="form-group col-sm-3">
            <input type="text" class="form-control font-13 radius-0 " [(ngModel)]="title"
                   placeholder="Title">
          </div>
          <div class="form-group col-sm-3">
            <input type="text" class="form-control radius-0 font-13 "
                   placeholder="Put your document content,keyword etc." [(ngModel)]="desc">
          </div>
          <div class="form-group col-sm-3">
            <input [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3"
                   class="form-control radius-0 font-13 "
                   [(ngModel)]="rDate" placeholder="Start Date">
            <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time>
          </div>
          <div class="form-group col-sm-3">
            <input [owlDateTimeTrigger]="dt4" [owlDateTime]="dt4"
                   class="form-control radius-0 font-13 "
                   [(ngModel)]="dDate" placeholder="Expiry Date">
            <owl-date-time [pickerType]="'calendar'" #dt4></owl-date-time>
          </div>
        </div>

<!--        <div class="row mar-lft-rgt-0">-->
<!--          <div class="col-sm-4 pad-15">-->
<!--            <mat-checkbox *ngFor="let action of actions;let i=index;" value="{{action.id}}"-->
<!--                          [(ngModel)]="action.checked"-->
<!--                          (change)="checkAll($event.checked,i)">{{action.action}}</mat-checkbox>-->
<!--          </div>-->
<!--          <div class="col-sm-3 pad-15">-->
<!--            <div class="form-group">-->
<!--              <mat-form-field>-->
<!--                <mat-label>Select Group</mat-label>-->
<!--                <mat-select multiple [(ngModel)]="supportGroupSelected" (selectionChange)="onGroupChange()">-->
<!--                  <mat-option *ngFor="let group of groups" [value]="group.id" [disabled]="group.isDisabled">{{group.name}}</mat-option>-->
<!--                </mat-select>-->
<!--              </mat-form-field>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="col-sm-3 pad-15">-->
<!--            <div class="form-group">-->
<!--              <mat-form-field>-->
<!--                <mat-label>Select Users</mat-label>-->
<!--                <mat-select [(ngModel)]="userSelected" (selectionChange)="onUserChange()" multiple>-->
<!--                  <mat-option *ngFor="let user of users" [value]="user.id" [disabled]="user.isDisabled">{{user.name}}</mat-option>-->
<!--                </mat-select>-->
<!--              </mat-form-field>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <div class="row mar-lft-rgt-0">
          <button type="button" class="btn btn-success btn-block font-13 radius-0 offset-4 col-sm-4" (click)="update()" *ngIf="upload">Update</button>
        </div>

      </mat-tab>
      <mat-tab label="Comments">
        <img class="loading-gif" src="../../../assets/img/loader.gif" [hidden]="comLoaded">
        <div class="mar-top-15 ">
          <div class="col-sm-12">
            <div class="form-group col-sm-12">
                  <textarea class="form-control radius-0 font-13 height-120"
                            placeholder="Put your comment here" [(ngModel)]="comment"></textarea>
            </div>
          </div>
          <div class="col-sm-12">
            <button *ngIf="delete || upload" type="button" class="btn btn-success btn-block" (click)="addComment()">
              Add Comment
            </button>
          </div>
          <div class="col-sm-12 mar-top-15">

            <div class="stepper-container vertical">
              <div class="stepper">
                <div class="step" *ngFor="let comment of comments;">
                  <div class="step-inner">
                    <div class="step-circle"><span><i class="fa fa-user"></i></span></div>
                  </div>
                  <div class="step-content col-sm-12 mar-top-15 mar-lft-rgt-0">
                    <div class="card radius-0">
                      <div class="card-header radius-0 card-header-top stepper-head">
                        <b>{{comment.name}}</b>
                        <b class="right"> {{comment.createddate| date:'medium'}}</b>
                      </div>
                      <div class="card-body">
                        {{comment.feedback}}
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Attachments">
        <table class="table font-13 mar-top-15 attachment">
          <thead class="thead-dark">
          <tr>
            <th>File</th>
            <th>Version</th>
            <th>Date</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let attachment of attachments;">
            <td><a href="{{attachment.attacheMent}}" target="_blank">{{attachment.fileName}}</a></td>
            <td>{{attachment.version}}</td>
            <td>{{attachment.createddate| date:'medium'}}</td>
          </tr>
          </tbody>
        </table>
      </mat-tab>

    </mat-tab-group>
  </div>

</ng-template>
<notifier-container></notifier-container>
